/**
 * Crypto compare icon
 */
import { APIs } from '@kattana-io/common';

const DEXE_COIN_NAME = 'DEXE';

/**
 *
 * @param symbols
 * @returns
 */
export const getCryptoComparePrices = async (symbols: any[]) => {
  const results = await Promise.all(
    symbols.map((s: any) => APIs.common.getTokensPrice(s))
  );

  let prices = {};
  results.map((r: any) => {
    prices = { ...prices, ...r.data.RAW };
    return null;
  });

  return prices;
};

export const getCDNIcon = (name: string) => {
  if (name === DEXE_COIN_NAME) {
    return 'https://kattana-icons.s3.amazonaws.com/DEXE.svg';
  }
  return `https://github.com/alexandrebouttier/coinmarketcap-icons-cryptos/blob/main/icons/${name?.toLocaleLowerCase()}.png?raw=true`;
};
